// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"InputLabel_InputLabel__KqUB1","Asterisk":"InputLabel_Asterisk__E3Wkm","FontSize":"InputLabel_FontSize__2WZeY","IconSize":"InputLabel_IconSize__yOfdz"};